import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function ChevronDownIcon({ width = 24, height = 24, color = 'black' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42z"
        fill={color}
      />
    </Svg>
  );
}

export default ChevronDownIcon;
